export const keys = {
  buttonAddFile: 'fileUpload.buttonAddFile',
};
